import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index/Index'
import Gaikuang from '../views/gaikuang/gaikuang'
import Ztzl from '../views/Ztzl/Ztzl'
import Gzly from '../views/Gzly/Gzly'
import MessageLists from '../views/Gzly/MessageLists'
import LeaveMessage from '../views/Gzly/LeaveMessage'
import Statistics from '../views/Gzly/Statistics'
import LiuyanInfo from '../views/Gzly/LiuyanInfo'
import Search from '../views/Search/Search'
import Dxarticles from '../views/Dxarticles/Dxarticles'
import MonList from '../views/MonList/MonList'
import MonListIn from '../views/MonList/MonListIn'
import GonggaoList from '../views/GonggaoList/GonggaoList'
import Ershida from '../views/ershida/ershida'
import Maps from '../views/Maps/Maps'
import Ershidasanzhong from '../views/ershida/sanzhongquanhui'
import Tousujubao from '../views/tousujubao/index'

Vue.use(VueRouter)

const routes = [
  {
    path:'/',
    component:Index,
    name:'Index',
    meta: {
        title: '保定国家高新技术产业开发区委员会',
        metaTags: [
            {
                name: 'SiteName',
                content: '保定国家高新技术产业开发区'
            },
            {
                name: 'SiteDomain',
                content: 'www.bdgxq.gov.cn'
            },
            {
                name: 'SiteIDCode',
                content: '1306000020'
            }
     
        ]
      }
},
{
    path:'/gaikuang/:id',
    component:Gaikuang,
    name:'Gaikuang',
    meta: {
        title: '保定国家高新技术产业开发区委员会 -- 高新概况',
        metaTags: [
            {
                name: 'SiteName',
                content: '保定国家高新技术产业开发区'
            },
            {
                name: 'SiteDomain',
                content: 'www.bdgxq.gov.cn'
            },
            {
                name: 'SiteIDCode',
                content: '1306000020'
            },
            {
                name: 'ColumnName',
                content: '高新概况'
            },
            {
                name: 'ColumnDescription',
                content: '保定国家高新技术产业开发区,高新概况'
            },
            {
                name: 'ColumnKeywords',
                content: '保定国家高新技术产业开发区,高新概况'
            },
            {
                name: 'ColumnType',
                content: '高新概况'
            }
        ]
      }
},
{
    path:'/Ztzl',
    component:Ztzl,
    name:'Ztzl',
    meta: {
        title: '保定国家高新技术产业开发区委员会 -- 专题专栏',
        metaTags: [
            {
                name: 'SiteName',
                content: '保定国家高新技术产业开发区'
            },
            {
                name: 'SiteDomain',
                content: 'www.bdgxq.gov.cn'
            },
            {
                name: 'SiteIDCode',
                content: '1306000020'
            },
            {
                name: 'ColumnName',
                content: '专题专栏'
            },
            {
                name: 'ColumnDescription',
                content: '保定国家高新技术产业开发区,专题专栏'
            },
            {
                name: 'ColumnKeywords',
                content: '保定国家高新技术产业开发区,专题专栏'
            },
            {
                name: 'ColumnType',
                content: '专题专栏'
            }
        ]
      }
},
{
    path:'/Gzly',
    component:Gzly,
    name:'Gzly',
    redirect: '/Gzly/MessageLists',
    meta: {
        title: '保定国家高新技术产业开发区委员会 -- 公众留言',
        metaTags: [
            {
                name: 'SiteName',
                content: '保定国家高新技术产业开发区'
            },
            {
                name: 'SiteDomain',
                content: 'www.bdgxq.gov.cn'
            },
            {
                name: 'SiteIDCode',
                content: '1306000020'
            },
            {
                name: 'ColumnName',
                content: '公众留言'
            },
            {
                name: 'ColumnDescription',
                content: '保定国家高新技术产业开发区,专题专栏'
            },
            {
                name: 'ColumnKeywords',
                content: '保定国家高新技术产业开发区,专题专栏'
            },
            {
                name: 'ColumnType',
                content: '公众留言'
            }
        ]
      },
    children:[
        {
            path:'MessageLists',
        component:MessageLists,
            meta: {
                title: '保定国家高新技术产业开发区委员会 -- 留言列表',
                metaTags: [
                    {
                        name: 'SiteName',
                        content: '保定国家高新技术产业开发区'
                    },
                    {
                        name: 'SiteDomain',
                        content: 'www.bdgxq.gov.cn'
                    },
                    {
                        name: 'SiteIDCode',
                        content: '1306000020'
                    },
                    {
                        name: 'ColumnName',
                        content: '留言列表'
                    },
                    {
                        name: 'ColumnDescription',
                        content: '保定国家高新技术产业开发区,留言列表'
                    },
                    {
                        name: 'ColumnKeywords',
                        content: '保定国家高新技术产业开发区,留言列表'
                    },
                    {
                        name: 'ColumnType',
                        content: '留言列表'
                    }
                ]
            },
        },
        {
            path:'LeaveMessage',
        component:LeaveMessage,
            meta: {
                title: '保定国家高新技术产业开发区委员会 -- 公众留言',
                metaTags: [
                    {
                        name: 'SiteName',
                        content: '保定国家高新技术产业开发区'
                    },
                    {
                        name: 'SiteDomain',
                        content: 'www.bdgxq.gov.cn'
                    },
                    {
                        name: 'SiteIDCode',
                        content: '1306000020'
                    },
                    {
                        name: 'ColumnName',
                        content: '公众留言'
                    },
                    {
                        name: 'ColumnDescription',
                        content: '保定国家高新技术产业开发区,公众留言'
                    },
                    {
                        name: 'ColumnKeywords',
                        content: '保定国家高新技术产业开发区,公众留言'
                    },
                    {
                        name: 'ColumnType',
                        content: '公众留言'
                    }
                ]
            },
        },
         {
            path:'Statistics',
        component:Statistics,
            meta: {
                title: '保定国家高新技术产业开发区委员会 -- 留言统计',
                metaTags: [
                    {
                        name: 'SiteName',
                        content: '保定国家高新技术产业开发区'
                    },
                    {
                        name: 'SiteDomain',
                        content: 'www.bdgxq.gov.cn'
                    },
                    {
                        name: 'SiteIDCode',
                        content: '1306000020'
                    },
                    {
                        name: 'ColumnName',
                        content: '留言统计'
                    },
                    {
                        name: 'ColumnDescription',
                        content: '保定国家高新技术产业开发区,留言统计'
                    },
                    {
                        name: 'ColumnKeywords',
                        content: '保定国家高新技术产业开发区,留言统计'
                    },
                    {
                        name: 'ColumnType',
                        content: '留言统计'
                    }
                ]
            },
        }
    ]
},
{
    path:'/ershida',
    component:Ershida,
    name:'Ershida',
    meta: {
        title: '保定国家高新技术产业开发区委员会 -- 深入学习贯彻党的二十大精神',
        metaTags: [
            {
                name: 'SiteName',
                content: '保定国家高新技术产业开发区'
            },
            {
                name: 'SiteDomain',
                content: 'www.bdgxq.gov.cn'
            },
            {
                name: 'SiteIDCode',
                content: '1306000020'
            },
            {
                name: 'ColumnName',
                content: '深入学习贯彻党的二十大精神'
            },
            {
                name: 'ColumnDescription',
                content: '保定国家高新技术产业开发区,深入学习贯彻党的二十大精神'
            },
            {
                name: 'ColumnKeywords',
                content: '保定国家高新技术产业开发区,深入学习贯彻党的二十大精神'
            },
            {
                name: 'ColumnType',
                content: '深入学习贯彻党的二十大精神'
            }
        ]
    },
},
    {
    path:'/ershidasanzhongquanhui',
    component:Ershidasanzhong,
    name:'Ershidasanzhong',
    meta: {
        title: '保定国家高新技术产业开发区委员会 -- 深入学习贯彻党的二十大精神',
        metaTags: [
            {
                name: 'SiteName',
                content: '保定国家高新技术产业开发区'
            },
            {
                name: 'SiteDomain',
                content: 'www.bdgxq.gov.cn'
            },
            {
                name: 'SiteIDCode',
                content: '1306000020'
            },
            {
                name: 'ColumnName',
                content: '深入学习贯彻党的二十大精神'
            },
            {
                name: 'ColumnDescription',
                content: '保定国家高新技术产业开发区,深入学习贯彻党的二十大精神'
            },
            {
                name: 'ColumnKeywords',
                content: '保定国家高新技术产业开发区,深入学习贯彻党的二十大精神'
            },
            {
                name: 'ColumnType',
                content: '深入学习贯彻党的二十大精神'
            }
        ]
    },
},
{
    path:'/LiuyanInfo/:id?',
    component:LiuyanInfo,
    name:'LiuyanInfo',
    meta: {
        title: '保定国家高新技术产业开发区委员会 -- 公众留言',
        metaTags: [
            {
                name: 'SiteName',
                content: '保定国家高新技术产业开发区'
            },
            {
                name: 'SiteDomain',
                content: 'www.bdgxq.gov.cn'
            },
            {
                name: 'SiteIDCode',
                content: '1306000020'
            },
            {
                name: 'ColumnName',
                content: '公众留言'
            },
            {
                name: 'ColumnDescription',
                content: '保定国家高新技术产业开发区,公众留言'
            },
            {
                name: 'ColumnKeywords',
                content: '保定国家高新技术产业开发区,公众留言'
            },
            {
                name: 'ColumnType',
                content: '公众留言'
            }
        ]
    },
},
{
    path:'/Search',
    component:Search,
    name:'Search',
    meta: {
        title: '保定国家高新技术产业开发区委员会 -- 信息检索',
        metaTags: [
            {
                name: 'SiteName',
                content: '保定国家高新技术产业开发区'
            },
            {
                name: 'SiteDomain',
                content: 'www.bdgxq.gov.cn'
            },
            {
                name: 'SiteIDCode',
                content: '1306000020'
            },
            {
                name: 'ColumnName',
                content: '信息检索'
            },
            {
                name: 'ColumnDescription',
                content: '保定国家高新技术产业开发区,信息检索'
            },
            {
                name: 'ColumnKeywords',
                content: '保定国家高新技术产业开发区,信息检索'
            },
            {
                name: 'ColumnType',
                content: '信息检索'
            }
        ]
    },
},
{
    path:'/Dxarticles/:id?',
    component:Dxarticles,
    name:'Dxarticles',
    meta: {
        title: '保定国家高新技术产业开发区委员会',
        metaTags: [
            {
                name: 'SiteName',
                content: '保定国家高新技术产业开发区'
            },
            {
                name: 'SiteDomain',
                content: 'www.bdgxq.gov.cn'
            },
            {
                name: 'SiteIDCode',
                content: '1306000020'
            },
            {
                name: 'ColumnName',
                content: '内容'
            },
            {
                name: 'ColumnDescription',
                content: '保定国家高新技术产业开发区'
            },
            {
                name: 'ColumnKeywords',
                content: '保定国家高新技术产业开发区'
            },
            {
                name: 'ColumnType',
                content: '内容'
            }
        ]
    },
},
{
    path:'/MonList',
    component:MonList,
    name:'MonList',
    meta: {
        title: '保定国家高新技术产业开发区委员会',
        metaTags: [
            {
                name: 'SiteName',
                content: '保定国家高新技术产业开发区 -- 财政预决算'
            },
            {
                name: 'SiteDomain',
                content: 'www.bdgxq.gov.cn'
            },
            {
                name: 'SiteIDCode',
                content: '1306000020'
            },
            {
                name: 'ColumnName',
                content: '财政预决算'
            },
            {
                name: 'ColumnDescription',
                content: '保定国家高新技术产业开发区, 财政预决算'
            },
            {
                name: 'ColumnKeywords',
                content: '保定国家高新技术产业开发区, 财政预决算'
            },
            {
                name: 'ColumnType',
                content: '财政预决算'
            }
        ]
    },
},
{
    path:'/MonListIn/:id?',
    component:MonListIn,
    name:'MonListIn',
    meta: {
        title: '保定国家高新技术产业开发区委员会',
        metaTags: [
            {
                name: 'SiteName',
                content: '保定国家高新技术产业开发区 -- 财政预决算'
            },
            {
                name: 'SiteDomain',
                content: 'www.bdgxq.gov.cn'
            },
            {
                name: 'SiteIDCode',
                content: '1306000020'
            },
            {
                name: 'ColumnName',
                content: '财政预决算内容'
            },
            {
                name: 'ColumnDescription',
                content: '保定国家高新技术产业开发区, 财政预决算内容'
            },
            {
                name: 'ColumnKeywords',
                content: '保定国家高新技术产业开发区, 财政预决算内容'
            },
            {
                name: 'ColumnType',
                content: '财政预决算内容'
            }
        ]
    },
},
{
    path:'/GonggaoList',
    component:GonggaoList,
    name:'GonggaoList',
    meta: {
        title: '保定国家高新技术产业开发区委员会',
        metaTags: [
            {
                name: 'SiteName',
                content: '保定国家高新技术产业开发区 -- 通知公告'
            },
            {
                name: 'SiteDomain',
                content: 'www.bdgxq.gov.cn'
            },
            {
                name: 'SiteIDCode',
                content: '1306000020'
            },
            {
                name: 'ColumnName',
                content: '通知公告'
            },
            {
                name: 'ColumnDescription',
                content: '保定国家高新技术产业开发区, 通知公告'
            },
            {
                name: 'ColumnKeywords',
                content: '保定国家高新技术产业开发区, 通知公告'
            },
            {
                name: 'ColumnType',
                content: '通知公告'
            }
        ]
    },
},
{
    path:'/Maps',
    component:Maps,
    name:'Maps',
    meta: {
        title: '保定国家高新技术产业开发区委员会',
        metaTags: [
            {
                name: 'SiteName',
                content: '保定国家高新技术产业开发区 -- 网站地图'
            },
            {
                name: 'SiteDomain',
                content: 'www.bdgxq.gov.cn'
            },
            {
                name: 'SiteIDCode',
                content: '1306000020'
            },
            {
                name: 'ColumnName',
                content: '网站地图'
            },
            {
                name: 'ColumnDescription',
                content: '保定国家高新技术产业开发区, 网站地图'
            },
            {
                name: 'ColumnKeywords',
                content: '保定国家高新技术产业开发区, 网站地图'
            },
            {
                name: 'ColumnType',
                content: '网站地图'
            }
        ]
    },
},
{
    path:'/tousujubao',
    component:Tousujubao,
    name:'Tousujubao',
    meta: {
        title: '保定国家高新技术产业开发区委员会',
        metaTags: [
            {
                name: 'SiteName',
                content: '保定国家高新技术产业开发区 -- 网站地图'
            },
            {
                name: 'SiteDomain',
                content: 'www.bdgxq.gov.cn'
            },
            {
                name: 'SiteIDCode',
                content: '1306000020'
            },
            {
                name: 'ColumnName',
                content: '网站地图'
            },
            {
                name: 'ColumnDescription',
                content: '保定国家高新技术产业开发区, 网站地图'
            },
            {
                name: 'ColumnKeywords',
                content: '保定国家高新技术产业开发区, 网站地图'
            },
            {
                name: 'ColumnType',
                content: '网站地图'
            }
        ]
    },
}
 
]

const router = new VueRouter({
//   mode: 'history',
//   base: process.env.BASE_URL,
//   base:'/gxq/',
  routes
})


router.beforeEach((to, from, next) => {
    // 更新页面标题和meta标签
    const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
    // 如果找到了有title的meta，就设置title
    if (nearestWithTitle) document.title = nearestWithTitle.meta.title;
    // 清除旧的meta标签
    Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
    // 添加新的meta标签
    to.meta.metaTags.forEach(tagDef => {
      const tag = document.createElement('meta');
      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });
    //   tag.setAttribute('data-vue-router-controlled', '');
    //   document.head.appendChild(tag);
    // 插入到head的第一个子元素之前
        const firstChild = document.head.firstChild;
        if (firstChild) {
        document.head.insertBefore(tag, firstChild);
        } else {
        document.head.appendChild(tag);
        }
    });
    next();
  });

export default router;

// export default router
